// extracted by mini-css-extract-plugin
export default {"backdrop":"src-components-organisms-modals-backdrop-Backdrop-module__backdrop--TsMXe"};